import { put, takeEvery } from 'typed-redux-saga';
import { initLogin, storeIsLogged } from "../actions";

export default function* watchInitLogin() {
  yield* takeEvery(initLogin, function* () {
    yield* put(storeIsLogged(false));
  });
}
